import { useGetCurrentCompanyApplicationQuery, useGetEnrolledPolicyPlansQuery } from "EmployerApplication/api";
import { useSelector } from "react-redux";

const EnrolledPolicyPlansLoader = ({ children }) => {
  const medicalPlanEnrolledId = useSelector((state) => state.medicalPlanEnrolledId);

  const { data: { companyIDToken } = {}, isLoading: isLoadingApplication } = useGetCurrentCompanyApplicationQuery();
  const { data: enrolledPlans, isLoading: isLoadingEnrolledPlans } = useGetEnrolledPolicyPlansQuery(
    { companyIDToken },
    { skip: !companyIDToken || !medicalPlanEnrolledId },
  );

  return children({
    enrolledPlans,
    medicalPlans: enrolledPlans?.medical_plans,
    isLoadingEnrolledPlans: isLoadingApplication || isLoadingEnrolledPlans,
  });
};

export default EnrolledPolicyPlansLoader;
